import { observer } from 'mobx-react';

import { tabsNavigationStore } from '../../store';

import { Tabs } from '@components/Tabs';

import { translate } from '@chaika/i18n/helper';

function Component() {
    const {
        navigationTabs: { titleParams = [], activeIndex, onTabClick },
    } = tabsNavigationStore;

    return (
        <div>
            <Tabs
                items={titleParams.map((titleParams, index) => ({
                    label: translate(titleParams.title),
                    key: index,
                }))}
                dataTest={''}
                activeIndex={activeIndex}
                onTabChange={onTabClick}
            />
        </div>
    );
}

export const TabsNavigation = observer(Component);
